import type { SearchItemType } from '@mimir/common/dto/itemTypes';
import { ItemType } from '@mimir/common/dto/itemTypes';
import type { RouterLink } from '@mimir/common/dto/searchModels';

export const getRouterLink = (itemType: SearchItemType, params: Record<string, any>, query: Record<string, any>): RouterLink => {
  let routeName = '';
  switch(itemType) {
    case ItemType.PERSON:
      routeName = 'personDetails';
      break;
    case ItemType.FOLDER:
      routeName = 'folderView';
      break;
    default:
      routeName = 'itemDetails';
      break;
  }
  return { name: routeName, params, query };
};
